// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss';

// Translatable strings
const strings = UncannyAutomator._core.i18n.components.item;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-action-menu-button-duplicate' )
export class AutomatorBuilderItemActionMenuButtonDuplicate extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties

	// The item ID (post ID)
	@property( { type: Number, attribute: 'item-id' } ) accessor itemID;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-button
				color="transparent"
				@click=${ this.handleDuplicateItem }
			>
				${ strings.duplicate }
			</uo-button>
		`;
	}

	/**
	 * Handles the item duplication
	 */
	handleDuplicateItem() {
		UncannyAutomator._core.recipe.item.duplicateAction(
			this.itemID
		);
	}
}
